import { useEffect, useState } from "react";
import { DatePicker, Form, Input, message, Modal, Upload } from "antd";
import moment from "moment";
import config from "../../../config";
import NetworkApi from "../../../network/networkApi";

interface Props {
  usage: any;
  onCancel: () => void;
  onSuccess: () => void;
}

export default function FarmlandUsageRenew({ usage, onCancel, onSuccess }: Props) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [files, setFiles] = useState<any[]>([]);
  const [uploading, setUploading] = useState(false);
  const leaseExtended = usage?.type === "rent";
  useEffect(() => {
    form.resetFields();
    setFiles([]);
    setUploading(false);
  }, [usage?.id, form]);

  const submit = async (values: any) => {
    if (uploading || saving) return;
    if (files.some(file => file.status !== "done" || !file.response?.result?.name)) {
      message.error("Файлуудыг амжилттай хуулсны дараа сунгана уу");
      return;
    }
    if (leaseExtended && !files.length) {
      message.error("Сунгасан түрээсийн гэрээг хавсаргана уу");
      return;
    }
    setSaving(true);
    try {
      const response = await NetworkApi.requestPost("/api/farmland/usage/renew", {
        id: usage.id, endDate: values.endDate.format("YYYY-MM-DD"),
        description: values.description.trim(), leaseExtended,
        files: files.map(file => ({
          name: file.name, tmp: file.response.result.name, type: file.response.result.mimetype,
        })),
      });
      if (response.resultCode === 200) {
        message.success(response.result?.status === "pending" ? "Сунгах хүсэлтийг илгээлээ" : "Зөвшөөрлийн хугацааг сунгалаа");
        onSuccess();
      } else message.error(response.message || "Сунгахад алдаа гарлаа");
    } catch {
      message.error("Сунгахад алдаа гарлаа. Дахин оролдоно уу");
    } finally { setSaving(false); }
  };

  return <Modal visible={!!usage} title="Тариан талбайн зөвшөөрөл сунгах"
    onCancel={onCancel} onOk={() => form.submit()} okText="Сунгах" cancelText="Болих"
    confirmLoading={saving} closable={!saving} maskClosable={!saving}
    cancelButtonProps={{ disabled: saving }} okButtonProps={{ disabled: uploading }}>
    <p>НТД: {usage?.farmland?.posNo} · Одоогийн дуусах огноо: {usage?.endDate}</p>
    <Form form={form} layout="vertical" onFinish={submit}>
      <Form.Item name="endDate" label="Шинэ дуусах огноо" rules={[{ required: true, message: "Шинэ дуусах огноо сонгоно уу" }]}>
        <DatePicker style={{ width: "100%" }} disabledDate={date =>
          !!date && (date.isSameOrBefore(moment(), "day") || date.isSameOrBefore(moment(usage?.endDate), "day"))
        } />
      </Form.Item>
      <Form.Item name="description" label="Сунгах тайлбар" rules={[{
        required: true, whitespace: true, message: "Сунгах тайлбар заавал оруулна уу",
      }]}>
        <Input.TextArea rows={4} maxLength={4000} />
      </Form.Item>
      <Form.Item label={leaseExtended ? "Сунгасан түрээсийн гэрээ (заавал)" : "Нэмэлт файл"}>
        <Upload name="file" action={`${config.get("apiUrl")}/api/file/upoad`}
          accept=".pdf,.jpg,.jpeg,.png,.gif"
          withCredentials fileList={files} maxCount={10} disabled={saving}
          onChange={({ fileList }) => {
            setFiles(fileList);
            setUploading(fileList.some(file => file.status === "uploading"));
            if (fileList.some(file => file.status === "error")) message.error("Файл хуулхад алдаа гарлаа");
          }}>
          <span style={{ cursor: "pointer", color: "#1890ff" }}>Файл хавсаргах</span>
        </Upload>
      </Form.Item>
    </Form>
  </Modal>;
}
